<template>
    <el-tabs v-model="decorationTab" type="card" class="education-content tabs-full">
        <el-tab-pane label="新客服管理" name="newkefuManage">
            <router-view />
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    data() {
        return {
            decorationTab: 'newkefuManage',
        };
    },
};
</script>

<style scoped lang="scss">
.education-content {
    height: 100%;
}
</style>
